import { lazy, Suspense } from "react";
import { useClientHydrated } from "@/hooks/useClientHydrated";
import HeroStatic from "./HeroStatic";

// Lazy load the animated version with Framer Motion
const HeroAnimated = lazy(() => import("./HeroAnimated"));

/**
 * Smart Hero component that loads static version first for LCP,
 * then lazy loads animations after client hydration
 */
const Hero = () => {
  const isHydrated = useClientHydrated();
  
  // Show static hero immediately, then switch to animated after hydration
  return isHydrated ? (
    <Suspense fallback={<HeroStatic />}>
      <HeroAnimated />
    </Suspense>
  ) : (
    <HeroStatic />
  );
};

export default Hero;
